<template>
  <!--
    中葡双语文案（与原型 i18n.js 排版规则一致）：
    块级场景：葡语另起一行（12px / #86909c）
    紧凑场景：单行「中文 / Português」
  -->
  <span class="bi" :class="inline ? 'bi-inline' : 'bi-block'">
    <span class="bi-zh">{{ zh }}</span>
    <span v-if="pt" class="bi-pt">{{ pt }}</span>
  </span>
</template>

<script>
export default {
  name: 'BiLabel',
  props: {
    zh: { type: String, default: '' },
    pt: { type: String, default: '' },
    inline: { type: Boolean, default: false }
  }
};
</script>

<style scoped lang="scss">
.bi {
  min-width: 0;
}
.bi-block {
  display: block;
}
.bi-inline {
  display: inline-flex;
  align-items: baseline;
  white-space: nowrap;
}
.bi-pt {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: inherit;
}
.bi-block .bi-pt {
  display: block;
  margin-top: 1px;
}
.bi-inline .bi-pt {
  margin-left: 4px;
}
.bi-inline .bi-pt::before {
  content: '/';
  margin-right: 4px;
}
</style>
